import { accordionSummaryClasses } from '@mui/material';

export default function AccordionSummary() {
  return {
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          flexDirection: 'row-reverse',
          padding: 0,

          [`&.${ accordionSummaryClasses.expanded }`]: {
            minHeight: '48px',
          },
        },
        expandIconWrapper: {
          transform: 'none',
          transition: 'none',
          marginRight: '.625rem',

          [`&.${ accordionSummaryClasses.expanded } svg`]: {
            rect: {
              fill: '#64CD87 !important',
            },
            line: {
              stroke: '#64CD87 !important',
            }
          },
        },
        content: {
          [`&.${ accordionSummaryClasses.expanded }`]: {
            margin: '12px 0',
          },
        },
      },
    },
  };
}
